<template lang="pug">
pr-wrapper.cms-detail-default(fs, bg, :bgo="gradient ? '.5' : '.85'")
  .cdd-wrapper(:class="{gradient:gradient}")
    .header.row.no-gutters
      .back.col.col-3.p-4(v-html="$t('press.backToBack')", style="whitespace: nowrap" v-visible="backButton")
      .title.col.col-6.py-4(:class="{ 'py-5': !hasMedia }")
        pr-subtitle(weight="semibold") {{ content.title }}
      .infobar.col.col-3.p-4
        info-bar(scope="cdd-infobar", data-down="cdd-carousel|cms-actions|cms-description", @nv-back="close")
    .media(v-if="hasMedia")
      .cdd-video.border(v-show="video")
        #cdd-video.surface-bg(:class="[content.orientation || 'horizontal']")
      .cdd-carousel(v-show="!video && gallery.length")
        .cdd-carousel-wrapper(
          v-visible="gallery_",
          v-nv:scope="'cdd-carousel'",
          data-scroll="center",
          data-up="cdd-infobar",
          data-down="cms-actions|cms-description",
          @nv-back="close"
        )
          .scroll-container
            imagec.mx-2.border.bordered(
              v-nv,
              v-for="(image, index) in gallery",
              vertical,
              :key="content.id + image.small",
              :src="image.small",
              @loaded="loaded"
            )
      .overlay(:class="{'surface-bg': !gradient}")
    .actions.d-flex.justify-content-center.pt-4(:class="{ 'pt-5': !hasMedia, 'surface-bg': !gradient }", v-if="hasAction")
      actions(@cart="addToCart", :data="content", data-up="cdd-carousel|cdd-infobar", data-down="cms-description", navigate, @nv-back="close")
    .content(:class="{'surface-bg': !gradient}")
      .content-wrapper.py-4(:class="{ 'py-5': !hasMedia }")
        description(:content="content.description", data-up="cms-actions|cdd-carousel|cdd-infobar", @nv-back="close")
</template>

<script>
import actions from "../layouts/actions.vue"
import description from "./helpers/description.vue"
export default {
  name: "cms-detail-default",
  components: { actions, description },
  props: ["content", "prevRoute"],
  data() {
    return {
      gallery_: false
    }
  },
  computed: {
    backButton() {
      return __.device.config("cms_back_button_behaviour.cms_back_button_behaviour") === "enable"
    },
    gradient() {
      return this.content.layout_gradient === "gradient"
    },
    gallery() {
      return this.content?.gallery ? (this.gallery_ ? this.content.gallery : this.content.gallery.slice(0, 1)) : []
    },
    cover() {
      return this.gallery.slice(0, 1).shift()
    },
    video() {
      return this.content.video || false
    },
    hasMedia() {
      return _$.true(this.video) || this.gallery.length
    },
    hasAction() {
      return (
        (["appointment", "reservation", "request"].includes(this.content.action_type) && this.content?.endpoint !== "pms") ||
        (["product"].includes(this.content.action_type) && this.content.price)
      )
    }
  },
  watch: {
    cover(nval, oval) {
      if (nval !== oval) this.gallery_ = false
    }
  },
  async activated() {
    if (this.cover) __.platform.background(this.cover.large, this.video).then(() => this.video && this.resizeMediaWrapper("cdd-video"))
    else if (this.video) __.media.play(this.video, true).then(() => this.resizeMediaWrapper("cdd-video"))

    if (document.getElementById("cdd-carousel")?.offsetParent) _$.nav.sync("cdd-carousel", true)
    else if (document.getElementById("cms-actions")?.offsetParent) _$.nav.changeScope("cms-actions")
    else if (document.getElementById("cms-description")?.offsetParent) _$.nav.changeScope("cms-description")
  },
  methods: {
    resizeMediaWrapper(id) {
      document.body.contains(this.$el) ? __.common.tvWindowResize(id) : __.media.stop()
    },
    close() {
      __.platform.go(this.prevRoute)
    },
    loaded() {
      if (document.getElementById("cdd-carousel")?.offsetParent) _$.nav.sync("cdd-carousel", true).then(() => (this.gallery_ = true))
    },
    addToCart(payload) {
      __.order.add(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.cdd-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  &.gradient {
    background: rgb(0, 0, 0);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.95) 10%, rgba(0, 0, 0, 0.5046393557422969) 70%, rgba(0, 0, 0, 0) 100%);
  }
  .header {
    align-items: center;

    .title {
      text-align: center;
    }
    .infobar {
      display: flex;
      justify-content: flex-end;
    }
  }

  .media {
    display: flex;
    flex: 0 0 auto;
    height: 368px;
    position: relative;
    margin-bottom: -1px;
    justify-content: center;

    .cdd-video,
    .cdd-carousel {
      flex: 1 0 auto;
      height: 100%;
      position: relative;
      z-index: 1;
    }

    .cdd-carousel {
      .cdd-carousel-wrapper {
        padding: 0 640px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;

        .scroll-container {
          display: inline-block;
          white-space: nowrap;
          height: 100%;

          .imagec {
            display: inline-block;
            border-width: 4px !important;
          }
        }
      }
    }
    .cdd-video {
      display: flex;
      justify-content: center;
      flex: 0 0 auto;
      border-width: 4px !important;

      #cdd-video {
        &.vertical {
          width: 202px;
          height: 360px;
        }
        &.square {
          width: 480px;
          height: 360px;
        }
        &.horizontal {
          width: 640px;
          height: 360px;
        }
      }
    }

    .overlay {
      position: absolute;
      bottom: 0;
      top: 50%;
      left: 0;
      right: 0;
    }
  }

  .actions {
    margin-bottom: -1px;
    padding-bottom: 1px;
  }

  .content {
    flex: 1 0 auto;
    text-align: center;
    position: relative;

    .content-wrapper {
      top: 0;
      bottom: 0;
      left: 50%;
      width: 50%;
      position: absolute !important;
      transform: translateX(-50%);
    }
  }
}
</style>
